/**
 * @file The extractor's half of a field's review status: `flagged` when any
 * check on the cell or fact `failed`, else `verified`. A `skipped` check never
 * flags. `edited` and `approved` depend on the staging's decisions overlay and
 * the job, so they are derived on top of this where the cell is read. Never
 * stored. Consumers: `routeSchedule` and the approval gate
 * (`scheduleApprovalBlockers`) in runLanguageModel, and S2's grid in React, so
 * every side flags the same cells.
 */
import type { MappedCellStatus, SourceCell, SourceFact } from './System.Agent.PdfEvidence.types';

export const cellStatus = (cell: Pick<SourceCell | SourceFact, 'checks'>): Extract<MappedCellStatus, 'verified' | 'flagged'> =>
    cell.checks.some((check) => check.result === 'failed') ? 'flagged' : 'verified';
